<template>

  <div class="bottom">
    <div class="b-name">
      <p>本服务由</p>
      <img src="../../../assets/svg/wallet/icon_pingan_logo.svg" alt>
      <p>提供监管</p>
    </div>
    <p class="b-desc">为您的资金安全提供强有力的保障</p>
  </div>
</template>

<script>
export default {
  name: 'BankIdentity'
}
</script>

<style scoped lang="scss">

.bottom {
  position: fixed;
  padding: .367rem 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;

  .b-name {
    border-radius: 0.027rem;
    border: 0.007rem solid #C2C2C2;
    color: #8B8B8B;
    font-size: 0.16rem;
    display: flex;
    flex-flow: nowrap;
    padding: 0.087rem 0.18rem;
    align-items: center;

    img {
      width: .707rem;
      height: .247rem;
      margin-left: .16rem;
      margin-right: .16rem;
    }

    p {
      letter-spacing: .027rem;
    }
  }

  .b-desc {
    font-size: .147rem;
    color: #B3B3B3;
    letter-spacing: .067rem;
    margin-top: 0.133rem;
    font-family: FZLTHJW--GB1-0, FZLTHJW--GB1, serif;
  }

}

</style>
